export const adminLogin = async (data) => {
  const form = new FormData();
  form.append("code", data.password);

  const response = await fetch("/api/auth/admin-login", {
    method: "POST",
    body: form,
    credentials: "include",
  });

  return response;
};

export const adminStatus = async () => {

  const response = await fetch("/api/auth/admin-status", {
    method: "GET",
    credentials: "include",
  });

  return response;
};

export const volunteerLogin = async (code) => {
  const form = new FormData();
  form.append("code", code);

  const response = await fetch("/api/auth/volunteer-login", {
    method: "POST",
    body: form,
    credentials: "include",
  });

  return response;
};

export const volunteerStatus = async () => {
  const response = await fetch("/api/auth/volunteer-status", {
    method: "GET",
    credentials: "include",
  });

  return response;
};

export const logout = async () => {
  const response = await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
  });

  return response;
};

export const getCSRFToken = async () => {
  const response = await fetch("/api/csrf-token", {
    credentials: "include",
  });

  const data = await response.json();

  return data.token;
};
